/**
 * UserAssignTeamsDialogController
 *
 * @author Guv Singh <gurvinder.singh.sandhu@gmail.com>
 */

export const RESULT_RESTORE = 'restore';
export const RESULT_RESTORE_AND_UPDATE = 'restore_and_update';

UserRestoreDialogController.$inject = ['$mdDialog', '$scope', 'existingUser'];

export function UserRestoreDialogController($mdDialog, $scope, existingUser) {
    $scope.cancel = cancel;
    $scope.restore = restore;
    $scope.restoreAndUpdate = restoreAndUpdate;

    $scope.existingUser = existingUser;

    function cancel() {
        $mdDialog.cancel();
    }

    function restore() {
        $mdDialog.hide(RESULT_RESTORE);
    }

    function restoreAndUpdate() {
        $mdDialog.hide(RESULT_RESTORE_AND_UPDATE);
    }
}
